<template>
	<div class="wrap wrap--products">
        <!-- 헤더 -->
		<main-header :header-type="'shop'"></main-header>

		<!-- 메인 -->
		<main class="main no-padding-top" role="main">
            <!-- 이벤트 배너 -->
			<div class="top-banner">
				<h2 class="title">새집처럼 <b>이벤트 ZONE!</b></h2>
			</div>
			<!-- 리스트 섹션 -->
			<section class="list-section">
				<div class="inner">
                    <board-list v-if="!$route.query.mode" code="store" skin="event"></board-list>
                    <board-view v-if="$route.query.mode == 'view'" skin="event" :_board="$route.params._board"></board-view>
				</div>
			</section>
		</main>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import BoardList from "@/components/client/board/board-list.vue";
import BoardView from "@/components/client/board/board-view.vue";

export default{
	components: {
		MainHeader,
		MainFooter,
        BoardList,
        BoardView,
	}
}
</script>
